// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from 'projects/tools/src/lib/store/puzzle-framework-config.model';

export const environment: EnvironmentModel = {
  production: false,
  firebase: {
    apiKey: 'foo',
    appId: 'foo',
  },
  revenuecat: {
    apiKeyApple: 'appl_DGfoFhiMCaOvTIJJsjfKgXcwmKZ',
    apiKeyGoogle: 'goog_PKdyzLZIdAzgddVxBdmwycyiEEs',
  },
  debug_puzzle_date: '20201016',
  internetTestUrl: 'https://puzzle-by.krupion.de/tagesraetsel/',
  internetTestWaitTime: 3000,
  puzzleFrameworkConfig: {
    title: 'Krupion Kreuzworträtsel default DEVMARKER',
    privacyPolicy: 'assets/privacy.html',
    googleAnalyticsCode: null,
    googleAnalyticsUpdateInterval: 0.5,
    adTagUrl: null,
    puzzleFiles: {
      daily7x7: {
        puzzleFile: 'https://puzzle-by.krupion.de/app-puzzles/swedish/7x7-daily/$date{yyyy-MM-dd}.xml',
        iap: {
          isFree: true,
        },
      },
      daily15x15: {
        puzzleFile: 'https://puzzle-by.krupion.de/app-puzzles/swedish/15x15-daily/$date{yyyy-MM-dd}.xml',
        iap: {
          isFree: false,
          permission: 'kreuzwort_daily15x15',
        },
        // Doesn't work at the moment :-/
        // configOverride: {
        //   jokerButton: {
        //     unit: 'absolute',
        //     value: 5,
        //   },
        // }
      },
      oops: {
        puzzleFile: '/assets/demo-puzzles/oops.xml',
      },
    },
    defaultPuzzle: 'wednesday',
    defaultLanguage: 'de',
    defaultGermanSalutation: 'du',
    jokerButton: {
      unit: 'absolute',
      value: 5,
      // unit: 'percent',
      // value: 5.5,
    },
    zoomOutLimit: 0.1,
    zoomInLimit: 3,
    minZoomOutSolutionWord: 0.7,
    minZoomOutSolutionWordMobile: 0.6,
    minAutoZoomOut: 0.9,
    minAutoZoomOutMobile: 0.65,
    maxAutoZoomIn: 2,
    maxAutoZoomInMobile: 2,
    androidPasswordInputFix: false,
    solutionUrl: '',
    mobileMinLandscapeHeight: 400,
    allowMobileVerticalTopBar: true,
    layout: {
      default: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 6,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 8,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 2,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 1
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
      small: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 11,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 1,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 4,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 3
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
      large: {
        width: 16,
        tiles: [
          {
            type: 'buttonbar',
            rows: 1,
            cols: 5,
          },
          {
            type: 'empty',
            rows: 1,
            cols: 9,
          },
          {
            type: 'timer',
            rows: 1,
            cols: 1,
          },
          // {
          //   type: 'moves',
          //   rows: 1,
          //   cols: 1
          // },
          {
            type: 'board',
            rows: 8,
            cols: 16,
          },
          {
            type: 'solutionWord',
            rows: 1,
            cols: 16,
          },
        ],
      },
    },
    buttonBarOrder: ['joker', 'check', 'zoom-in', 'zoom-out', 'reset', 'help', 'privacy', 'fullscreen'],
    showTimer: false,
    customButtons: [
      {
        showName: false,
        name: 'Info',
        showIcon: true,
        icon: 'insert_emoticon',
        showImage: false,
        showTooltip: true,
        url: 'https://www.google.com',
      },
      {
        showName: false,
        showIcon: false,
        showImage: true,
        image: './assets/Demo/facebook.png',
        showTooltip: true,
        url: 'https://www.facebook.com',
      },
    ],
    hideWelcomeDialog: false,
    hideWelcomeBackDialog: false,
    wordSearchBottomWordListOnly: false,
    winScreenPrintButton: false,
    solutionWordConfig: {
      sweepstake: {
        enabled: false,
      },
      solutionDialogEnabled: false,
    },
    urlLanguageParameterEnabled: false,
    swedishPuzzleLegacy: false,
    autoZoomEnabledDefaultMobile: true,
    autoZoomEnabledDefaultDesktop: true,
    definitionBarEnabledDefaultMobile: true,
    definitionBarEnabledDefaultDesktop: true,
    crosswordBoardConfig: {
      definFields: 'default',
      crosswordSidebar: 'default',
      fieldNumbers: 'default',
      splitWordList: 'default',
      splitDefinList: 'default',
    },
    removeSideMargins: false,
    nativeKeyboard: false,
    nativeKeyboardAllowUserChange: true,
    keepKeyboardOpen: false,
    keepKeyboardOpenAllowUserChange: true,
    showSolutionTime: 2000,
    weekStartOffsetFromMonday: 0,
    IAP: {
      noWaitingScreenPermissionId: 'no_waiting_screen',
      waitingScreenCountdownSeconds: 1,
    },
    rumpelstilzchenNoReload: ['9e376eff2d459d49d5c9185fff6987a5'],
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
